import { Outlet } from "react-router-dom";
import HeaderLayout from "../header";
import UserNav from "../navbar/userNav";
import AdminNav from "../navbar/adminNav";
import css from "./style.module.css";
import { useAuth } from "../../auth";

const BaseLayout = () => {
  const { isAdmin } = useAuth();

  return (
    <div className={css["root"]}>
      <HeaderLayout />
      {isAdmin ? <AdminNav /> : <UserNav />}
      <Outlet />
    </div>
  );
};

export default BaseLayout;
